import memoize from 'fast-memoize';

import { RouteConfigType } from 'Containers/App/Layout/utils';

type Route = RouteConfigType & {
  test?: string | undefined;
};

type MatchedRouteConfig = {
  match: {
    params: Record<string, string>;
    path: string;
    url: string;
  };
  routeConfig: Route | undefined;
};

const findMatchedRouteConfigFunc = (path: string, config: Route[]): MatchedRouteConfig => {
  let match;
  const routeConfig = config.find((route: Route) => {
    const cleanPath = path.endsWith('/') ? path.slice(0, -1) : path;
    const pathDefinition = route.path;
    // https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1199
    const matchPattern = new URLPattern({ pathname: pathDefinition }); // eslint-disable-line no-undef
    const isMatched = matchPattern.test({ pathname: cleanPath });
    // match the first
    if (isMatched && !match) {
      const matchedObject = matchPattern.exec({ pathname: cleanPath });
      const params = matchedObject?.pathname.groups;
      const returnedObject = {
        params,
        path: pathDefinition, // the path used to match
        url: cleanPath,
      };
      match = returnedObject;
    }
    return match;
  });

  return {
    routeConfig,
    match,
  };
};

export const findMatchedRouteConfig: (path: string, config: Route[]) => MatchedRouteConfig =
  memoize(findMatchedRouteConfigFunc);
